import React from "react";
import { publications } from "../data/publications";

const Research = () => {
    return (
        <section id="classes" className="font-body">
            <div className="container px-5 py-10 mx-auto text-center lg:px-40">
                <div className="flex flex-col w-full mb-20">
                    <h1 className="sm:text-4xl text-3xl font-medium font-title mb-8">
                        Research
                    </h1>
                    <p className="mb-4">
                        I am grateful to have worked under the supervision of <a href="http://www.pollack.uga.edu" className="underline" target="_blank">Paul Pollack</a>.
                        My interests include problems in analytic and enumerative combinatorics, as well as analytic number theory. I seek to
                        understand the subtle interplay between additive and multiplicative number theory, as highlighted by the connections
                        between integers and integer partitions. The parallels between the combinatorial and analytic properties of power series,
                        Dirichlet series, and modular forms remain a great mystery I strive to illuminate. I had a series of successful projects
                        reviewing and writing mathematical models of infectious diseases. The computational skills I developed during this time I
                        now utilize to develop and prove conjectures in number theory.
                    </p>
                    <p>
                        While I enjoy research at the highest level, guiding younger
                        students into the joys of research is a priority for me. I serve as a mentor for the Directed Reading Program (DRP) and the
                        Undergraduate Research Mentor for combinatorics and number theory. I have mentored 10+ students in many areas of pure math
                        and math education, and my collaborative efforts have led to 1 accepted publication, and multiple publications in preparation.
                    </p>
                </div>
                <h2 className="sm:text-2xl text-2xl font-semibold mb-8 font-title">
                    Publications
                </h2>
                <div className="flex flex-col items-center font-body">
                    <ol className="text-left text-lg list-decimal">
                        {publications.map((publication, index) => (
                            <li key={index} className="pl-2 pb-4">
                                <p className="font-bold">
                                    {publication.title}
                                </p>
                                <p>
                                    {`(w/ ${publication.authors})`}
                                    <span className="italic">{publication.subtitle},{" "}
                                        <span className="font-bold">{publication.boldNumbers}</span>
                                    </span>
                                    <span>
                                        ({publication.year}), {publication.pageNumbers}.{" "}

                                        {publication.link &&
                                            <a
                                                href={publication.link}
                                                target="_blank"
                                                className="underline text-gray-400 hover:text-highlight">
                                                pdf
                                            </a>}
                                    </span>
                                </p>

                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
export default Research;


// WEBPACK FOOTER //
// ./src/components/Research.jsx